import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, project, params) => {
    return `${host}/cp/${project}/get_training_videos${params}`
  },
  checkRequiredArguments: () => {},
  makeResponseData: (json) => {
    return json
    }
}
export default createFetcher(fetcherConfiguration)
